<template>
  <div>
    <va-card>
      <va-data-table
        :fields="fields"
        :data="banners"
        class="va-table va-table--hoverable va-table--clickable"
        api-mode
      >
        <template slot="id" slot-scope="props">
          <span>{{ props.rowData.id }}</span>
        </template>
        <template slot="name" slot-scope="props">
          <span class="promo-banner__img">
            <img :src="props.rowData.url" :alt="props.rowData.id" />
          </span>
        </template>
        <template slot="status" slot-scope="props">
          <span>
            <template v-if="props.rowData.active">Вкл</template>
            <template v-else>Выкл</template>
          </span>
        </template>
        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-pencil"
            @click="update(props.rowData)"
          />
          <va-button
            flat
            small
            color="gray"
            icon="fa fa-trash"
            @click="remove(props.rowData.id)"
          />
        </template>
      </va-data-table>
    </va-card>

    <va-modal v-model="showUpdateForm" size="large" hide-default-actions>
      <promo-banner-edit
        v-if="currentBanner"
        :banner="currentBanner"
        @hide="modalStatus"
      ></promo-banner-edit>
    </va-modal>
  </div>
</template>

<script>
import api from "@/api/axios";
import { mapActions } from "vuex";
import PromoBannerEdit from "./promo-banner-edit.vue";
export default {
  components: { PromoBannerEdit },
  props: {
    banners: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showUpdateForm: false,
      currentBanner: null,
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "__slot:id",
          title: "Номер",
        },
        {
          name: "__slot:name",
          title: "Фотография",
        },
        {
          name: "__slot:status",
          title: "Статус",
        },
        {
          name: "__slot:actions",
          title: "",
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      fetchPromoBanners: "promoBanners/getPromoBanners",
    }),
    async remove(promoBannerId) {
      if (confirm("Вы действительно хотите удалить ?")) {
        try {
          await api.delete(`/admin/promo-banners/${promoBannerId}`);
          await this.fetchPromoBanners();
        } catch (error) {
          return error;
        }
      }
    },
    update(val) {
      this.currentBanner = val;
      this.showUpdateForm = !this.showUpdateForm;
    },
    modalStatus() {
      this.showUpdateForm = !this.showUpdateForm;
    },
  },
};
</script>

<style scoped>
.promo-banner__img img {
  display: block;
  object-fit: contain;
  width: 150px;
  height: 150px;
}
</style>
